<h2 mat-dialog-title>{{ 'DeleteContract' | translate }}</h2>
<mat-dialog-content>
    <p>{{ 'DeleteContractConfirmation' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button color="warn" (click)="confirm()">{{ 'DeleteContract' | translate }}</button>
</mat-dialog-actions>
